import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';

import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
    const authService: AuthService = inject(AuthService);
    const router: Router = inject(Router);

    return authService.checkAuthentication().pipe(
        switchMap((authenticated) => {
            // If the user is not authenticated
            if (!authenticated) {
                // Redirect to the login page
                router.navigateByUrl('/login');

                // Prevent the access
                return of(false);
            }

            // Allow the access
            return of(true);
        })
    );
};
